import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { calendarService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as calendarsActions from './actions';

export function fetchCalendar(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_ONE),
    mergeMap(({ payload }) => {
      return calendarService.getCalendarById(payload)
        .pipe(
          map(res => calendarsActions.fetchCalendarSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function fetchCalendars(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_COLLECTION),
    mergeMap(({ payload }) => {
      return calendarService.getCalendars(payload)
        .pipe(
          map(res => calendarsActions.fetchCalendarsSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function saveCalendarFavorite(action$) {
  return action$.pipe(
    ofType(actionTypes.SAVE_FAVORITE),
    mergeMap(({ payload }) => {
      return calendarService.saveFavorite(payload)
        .pipe(
          map(res => calendarsActions.saveCalendarFavoriteSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function removeCalendarFavorite(action$) {
  return action$.pipe(
    ofType(actionTypes.REMOVE_FAVORITE),
    mergeMap(({ payload }) => {
      return calendarService.removeFavorite(payload)
        .pipe(
          map(res => calendarsActions.removeCalendarFavoriteSuccess(payload)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}
export function getCalendarFavorites(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_FAVORITES),
    mergeMap(({ payload }) => {
      return calendarService.getFavorites(payload)
        .pipe(
          map(res => calendarsActions.getCalendarFavoritesSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}